import React, { useState, useEffect } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { ProjectLayout } from "components/Project/ProjectLayout";
import ProjectHome from "components/Project/ProjectHome";
import { getProfileSolutions } from "api/solutions";
import { useOrganization } from "hooks/OrganizationContext";

export default function Projects() {
  const [refreshMode, setRefreshMode] = useState('');
  const [loading, setLoading] = useState(true);
  const [userProjects, setUserProjects] = useState<any>([]);
  const { selectedOrganization } = useOrganization();

  const getAllProjects = async (id: string) => {
    const response = await getProfileSolutions(id);
    if (response.status === 200) {
      const newProjects = response.data.list.map((item: any) => {
        return {
          ...item,
          title: item.name,
          type: "PROJECT",
          bgColor: "bg-gradient-to-b from-green to-blue",
          icon: "/images/cpu.svg",
          status: "Private Project",
          link: item.url,
          isEditable: true
        };
      });
      setUserProjects(newProjects);
    }
  };


  useEffect(() => {
    setUserProjects([]);
    getAllProjects(selectedOrganization.id);
  }, [selectedOrganization, refreshMode]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCaAnlPllExl2Yuk5G6RENFb0zlBQUXFWY",
  });
  useEffect(() => {
    if (isLoaded) {
      setLoading(false);
    }
  }, [isLoaded, userProjects]);
  

  return !loading ? (
    <ProjectLayout>
      <ProjectHome setRefreshMode={setRefreshMode} refreshMode={refreshMode} />
     
    </ProjectLayout>
  ) : (
    <></>
  );
}